export {default} from './policies-and-notes';
